
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Bridal = lazy(() => import('../pages/bridal/page'));
const Signature = lazy(() => import('../pages/signature/page'));
const Product = lazy(() => import('../pages/product/page'));
const Cart = lazy(() => import('../pages/cart/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const FAQ = lazy(() => import('../pages/faq/page'));
const ShippingReturns = lazy(() => import('../pages/shipping-returns/page'));
const SizeGuide = lazy(() => import('../pages/size-guide/page'));
const ProductCare = lazy(() => import('../pages/product-care/page'));
const WarrantyRepairs = lazy(() => import('../pages/warranty-repairs/page'));
const Terms = lazy(() => import('../pages/terms/page'));
const Privacy = lazy(() => import('../pages/privacy/page'));
const Cookies = lazy(() => import('../pages/cookies/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const Wishlist = lazy(() => import('../pages/wishlist/page'));
const About = lazy(() => import('../pages/about/page'));
const GiftGuide = lazy(() => import('../pages/gift-guide/page'));
const ThankYou = lazy(() => import('../pages/thank-you/page'));
const Account = lazy(() => import('../pages/account/page'));
const AccountOrders = lazy(() => import('../pages/account/orders/page'));
const AccountProfile = lazy(() => import('../pages/account/profile/page'));
const AccountAddresses = lazy(() => import('../pages/account/addresses/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/bridal',
    element: <Bridal />,
  },
  {
    path: '/signature',
    element: <Signature />,
  },
  {
    path: '/product/:id',
    element: <Product />,
  },
  {
    path: '/cart',
    element: <Cart />,
  },
  {
    path: '/wishlist',
    element: <Wishlist />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/gift-guide',
    element: <GiftGuide />,
  },
  {
    path: '/thank-you',
    element: <ThankYou />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/faq',
    element: <FAQ />,
  },
  {
    path: '/shipping-returns',
    element: <ShippingReturns />,
  },
  {
    path: '/size-guide',
    element: <SizeGuide />,
  },
  {
    path: '/product-care',
    element: <ProductCare />,
  },
  {
    path: '/warranty-repairs',
    element: <WarrantyRepairs />,
  },
  {
    path: '/terms',
    element: <Terms />,
  },
  {
    path: '/privacy',
    element: <Privacy />,
  },
  {
    path: '/cookies',
    element: <Cookies />,
  },
  {
    path: '/account',
    element: <Account />,
  },
  {
    path: '/account/orders',
    element: <AccountOrders />,
  },
  {
    path: '/account/profile',
    element: <AccountProfile />,
  },
  {
    path: '/account/addresses',
    element: <AccountAddresses />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
